export default [
  {
    component: () => import("pages/TranscriptRequestList.vue"),
    meta: {
      accessLevel: "limited",
      title: "Transcript Item Requests",
    },
    name: "transcript-requests-index",
    path: "/transcript-requests",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/TranscriptRequestEdit.vue"),
    meta: {
      title: "Edit Transcript Request",
    },
    name: "transcript-requests-edit",
    path: "/transcript-requests/:transcriptRequestId/edit",
    props: true,
  },
  {
    component: () => import("pages/TranscriptRequestEdit.vue"),
    meta: {
      accessLevel: "limited",
      title: "New Transcript Item Request",
    },
    name: "transcript-requests-new",
    path: "/transcript-requests/new",
    props: true,
  },
  {
    component: () => import("pages/MediaRequestList.vue"),
    meta: {
      accessLevel: "limited",
      title: "Media Item Requests",
    },
    name: "media-requests-index",
    path: "/media-requests",
  },
];
